import { render } from "./DashCoefficients.vue?vue&type=template&id=067f8e54&scoped=true&ts=true"
import script from "./DashCoefficients.vue?vue&type=script&lang=ts"
export * from "./DashCoefficients.vue?vue&type=script&lang=ts"

import "./DashCoefficients.vue?vue&type=style&index=0&id=067f8e54&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-067f8e54"]])

export default __exports__